<template>
	<div class="christmas-offer-chart">
		<svg viewBox="0 0 321 151" fill="none" xmlns="http://www.w3.org/2000/svg">
			<line
				x1="80.3686"
				y1="2.32366"
				x2="80.3686"
				y2="133.676"
				stroke="#E2E3EE"
				stroke-width="0.647328"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<line
				x1="153.369"
				y1="2.32366"
				x2="153.369"
				y2="133.676"
				stroke="#E2E3EE"
				stroke-width="0.647328"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<line
				x1="233.369"
				y1="2.32366"
				x2="233.369"
				y2="133.676"
				stroke="#E2E3EE"
				stroke-width="0.647328"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<text fill="#6A6D82" font-size="12" font-weight="300">
				<tspan x="4.57" y="148" text-anchor="start">{{ t('offers.christmas.pre.chart.now') }}</tspan>
			</text>
			<line
				x1="3.36859"
				y1="2.32366"
				x2="3.36858"
				y2="133.676"
				stroke="#E2E3EE"
				stroke-width="0.647328"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<line
				x1="311.369"
				y1="2.32366"
				x2="311.369"
				y2="133.676"
				stroke="#E2E3EE"
				stroke-width="0.647328"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<text fill="#6A6D82" font-size="12" font-weight="300">
				<tspan x="299.57" y="148" text-anchor="start">{{ endMonth }}</tspan>
			</text>
			<circle cx="5" cy="24.5" r="4.5" fill="#7D8BF7" />
			<text fill="#3B3C57" font-size="12" font-weight="300">
				<tspan x="4" y="16" text-anchor="start">{{ startWeight }}</tspan>
			</text>
			<path
				d="M310.651 90.1161C273 90.1161 175.422 95.3639 120 73.5C65.5 52 47 24 5.5 24"
				stroke="#7D8BF7"
				stroke-width="3"
			/>
			<path d="M311.651 90.116C286.256 90.116 232.597 92.5034 184 87.3486" stroke="#F3AA51" stroke-width="3" />
			<g filter="url(#filter0_d_228_3188)">
				<path
					d="M154.5 33C154.5 31.8954 155.395 31 156.5 31H212.054C213.159 31 214.054 31.8954 214.054 33V67C214.054 68.1045 213.159 69 212.054 69H190.328C189.798 69 189.289 69.2107 188.914 69.5857L185.207 73.2929C184.817 73.6834 184.183 73.6834 183.793 73.2929L180.086 69.5857C179.711 69.2107 179.202 69 178.672 69H156.5C155.395 69 154.5 68.1045 154.5 67V33Z"
					fill="#7D8BF7"
				/>
			</g>
			<text fill="white" font-size="12" font-weight="600">
				<tspan x="168.63" y="54.77" text-anchor="start">{{ endWeight }}</tspan>
			</text>
			<path
				d="M120 73.5C65.5 52 45 24 3.5 24V133H184.5V87.3751C184.5 87.3751 138.104 80.6421 120 73.5Z"
				fill="url(#paint0_linear_228_3188)"
			/>
			<path
				d="M311.651 133V90.1159C286.299 90.1159 184.5 87.375 184.5 87.375V133H311.651Z"
				fill="url(#paint1_linear_228_3188)"
			/>
			<text fill="#F3AA51" font-size="12" font-weight="800">
				<tspan x="200.75" y="114" text-anchor="start">{{ t('offers.christmas.pre.chart.maintain_weight') }}</tspan>
			</text>
			<circle cx="185" cy="87.5" r="7.42408" fill="#7D8BF7" stroke="white" stroke-width="1.84817" />
			<defs>
				<filter
					id="filter0_d_228_3188"
					x="144.5"
					y="25"
					width="79.5542"
					height="62.5859"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="5" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_228_3188" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_228_3188" result="shape" />
				</filter>
				<linearGradient
					id="paint0_linear_228_3188"
					x1="158.076"
					y1="24"
					x2="158.076"
					y2="133"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#7D8BF7" stop-opacity="0.57" />
					<stop offset="1" stop-color="#7D8BF7" stop-opacity="0" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_228_3188"
					x1="158.076"
					y1="24"
					x2="158.076"
					y2="133"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#F3AA51" stop-opacity="0.87" />
					<stop offset="1" stop-color="#F3AA51" stop-opacity="0" />
				</linearGradient>
			</defs>
		</svg>
	</div>
</template>

<style lang="scss" scoped>
.christmas-offer-chart {
	margin-bottom: 2.6rem;

	svg {
		display: block;
		margin: auto;
		width: 100%;
	}
}
</style>

<script>
import { computed } from '@vue/reactivity'
import { addDays, format } from 'date-fns'
import { useI18n } from 'vue-i18n'
import useApi from '@/composition/api'
import { mapI18nToDateFnsLocale } from '@/utils/i18nDateFnsHelper.js'

export default {
	name: 'ChristmasOfferChart',
	props: {
		weight: {
			type: Number,
			default: 89
		},
		targetWeight: {
			type: Number,
			default: 70
		},
		isMetric: {
			type: Boolean,
			default: false
		},
		daysToGoal: {
			type: Number,
			default: 0
		}
	},
	setup(props) {
		const api = useApi()
		const lang = api.getLanguage()
		const { t } = useI18n()
		const startWeight = computed(
			() =>
				`${Math.trunc(props.isMetric ? props.weight : props.weight * 2.205).toString()} ${
					!props.isMetric ? t('lbs') : t('kg')
				}`
		)
		const endWeight = computed(
			() =>
				`${Math.trunc(props.isMetric ? props.targetWeight : props.targetWeight * 2.205).toString()} ${
					!props.isMetric ? t('lbs') : t('kg')
				}`
		)
		const endMonth = computed(() =>
			format(addDays(Date.now(), props.daysToGoal), 'MMM', { locale: mapI18nToDateFnsLocale(lang) })
		)

		return {
			t,
			startWeight,
			endWeight,
			endMonth
		}
	}
}
</script>
